/**
 * PiataHeader — header partajat pentru paginile Pieței Micilor Producători.
 */
import { Link } from 'react-router-dom';
import { ShoppingBasket, UserCircle2 } from 'lucide-react';
import EPDLogo from './EPDLogo';
import GlobalTranslator from './GlobalTranslator';
import { useAuth } from '../contexts/AuthContext';

export default function PiataHeader({ active = 'piata' }) {
  const { user } = useAuth();
  return (
    <header className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-xl border-b border-zinc-200/70">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="shrink-0"><EPDLogo /></Link>
        <div className="hidden lg:flex items-center gap-5 text-[13px] font-medium">
          <Link to="/" className="text-zinc-600 hover:text-zinc-950">Acasă</Link>
          <Link to="/piata" className={active === 'piata' ? 'text-zinc-950 font-semibold' : 'text-zinc-600 hover:text-zinc-950'} data-testid="piata-nav-market">Piața producătorilor</Link>
          <Link to="/piata/vinde" className={active === 'vinde' ? 'text-zinc-950 font-semibold' : 'text-zinc-600 hover:text-zinc-950'} data-testid="piata-nav-sell">Vinde gratuit</Link>
          {user && (
            <Link to="/piata/cont" className={active === 'cont' ? 'text-zinc-950 font-semibold' : 'text-zinc-600 hover:text-zinc-950'} data-testid="piata-nav-account">Contul meu</Link>
          )}
          <Link to="/contact" className="text-zinc-600 hover:text-zinc-950">Contact</Link>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <GlobalTranslator variant="light" />
          {user ? (
            <Link to="/piata/cont" className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 text-xs border border-zinc-300 hover:border-zinc-950 text-zinc-700 font-semibold rounded-md transition-colors" data-testid="piata-header-account">
              <UserCircle2 className="w-3.5 h-3.5" /> Cont
            </Link>
          ) : (
            <Link to="/auth?mode=signin" className="hidden sm:inline-flex items-center px-3 py-1.5 text-xs border border-zinc-300 hover:border-zinc-950 text-zinc-700 font-semibold rounded-md transition-colors" data-testid="piata-header-login">
              Autentificare
            </Link>
          )}
          <Link to="/piata/vinde" className="epd-btn text-sm py-2 whitespace-nowrap" data-testid="piata-header-sell-cta">
            <ShoppingBasket className="w-3.5 h-3.5" />
            Vinde gratuit
          </Link>
        </div>
      </div>
    </header>
  );
}
